module.exports = __webpack_public_path__ + "img/9f7e983671dae9a322c2f3977b2108aa.svg";